import {
    SET_LOADING,
    SET_DATA,
    FILTER_DATA,
    SET_CURRENT_PAGE,
    SET_SORT,
    SET_MAP_VIEW,
    TOGGLE_FILTER,
    TOGGLE_OPTION,
    UNSET_OPTIONS,
    SET_RANGE,
    RESET_RANGE
} from '../types';

import { getItemsListOrdered } from '../selectors';

function markAvailableDictionaries(dictionaries, items) {

    // first run - remove items
    // others hide

    // all false by default
    Object.keys(dictionaries).forEach(function (key, index) {
        let dictionaryOptions = dictionaries[key];
        Object.keys(dictionaryOptions).forEach(function (optionKey) {
            optionKey = Number(optionKey);
            //let optionValue = dictionaryOptions[optionKey];
            dictionaryOptions[optionKey] = false;
            // find one and set to true
            items.forEach(function (item) {
                if (dictionaryOptions[optionKey] === true) {
                    return true; // break asap
                }
                if (item[key]) {
                    if (key === 'f' || key === 'c' || key === 'gn') {
                        if (item[key] == optionKey) {
                            dictionaryOptions[optionKey] = true;
                        }
                    } else {
                        if (Array.isArray(item[key])) {
                            if (item[key].indexOf(optionKey) >= 0) {
                                dictionaryOptions[optionKey] = true;
                            }
                        }
                    }
                }
            });
        });
    });

    return dictionaries;
}

export default (state, action) => {
    switch (action.type) {

        case SET_LOADING:
            return {
                ...state,
                loaded: false
            };

        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };

        case SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case SET_MAP_VIEW:
            return {
                ...state,
                showMap: action.payload
            };

        case TOGGLE_FILTER:
            let ident = action.payload;
            let activeFilters = [...state.activeFilters];
            // remove if exists and add 
            const found = activeFilters.indexOf(ident);
            if (found >= 0) {
                activeFilters.splice(found, 1);
            } else {
                activeFilters.push(ident);
            }

            return {
                ...state,
                activeFilters: activeFilters
            };

        case TOGGLE_OPTION:
            let { filterIdent, optionIdent } = action.payload;
            let activeOptions = { ...state.activeOptions };
            if (!activeOptions[filterIdent]) {
                activeOptions[filterIdent] = [];
            }
            // remove if exists and add 
            const foundOption = activeOptions[filterIdent].indexOf(optionIdent);
            if (foundOption >= 0) {
                activeOptions[filterIdent].splice(foundOption, 1);
            } else {
                activeOptions[filterIdent].push(optionIdent);
            }

            return {
                ...state,
                activeOptions: activeOptions,
                currentPage: 1
            };
        case UNSET_OPTIONS:
            let activeOptionsCopy = { ...state.activeOptions };
            delete (activeOptionsCopy[action.payload]);
            return {
                ...state,
                activeOptions: activeOptionsCopy,
                currentPage: 1
            };


        case SET_RANGE:
            let min = state.dataRangeMin === 0 ? action.payload.min : state.dataRangeMin;
            let max = state.dataRangeMax === 0 ? action.payload.max : state.dataRangeMax;

            return {
                ...state,
                dateRange: action.payload,
                dataRangeMin: min,
                dataRangeMax: max,
                currentPage: 1
            };

        case RESET_RANGE:
            return {
                ...state,
                dateRange: { min: state.dataRangeMin, max: state.dataRangeMax },
                currentPage: 1
            };

        case FILTER_DATA:
            let filtered = getItemsListOrdered(state);
            return {
                ...state,
                dataFiltered: filtered,
                availableDictionaries: markAvailableDictionaries(JSON.parse(JSON.stringify(state.dictionaries)), filtered),
                currentPage: 1
            };

        case SET_DATA:
            let dictionaries = { ...action.payload.data };
            delete (dictionaries.products);
            let availableDictionaries = JSON.parse(JSON.stringify(dictionaries));// Object.assign({}, dictionaries);//let availableDictionaries = { ...dictionaries };
            return {
                ...state,
                data: action.payload.data.products,
                loadedDate: action.payload.loadedDate,
                dataFiltered: [...action.payload.data.products],
                dictionaries: dictionaries,
                availableDictionaries: markAvailableDictionaries(availableDictionaries, action.payload.data.products),
                loaded: true
            };

        default:
            return state;

    }
};